module.exports = __webpack_public_path__ + "img/porsche.13dba326.png";